import { supabase } from "../../lib/supabase.js";

export default function PendingApproval({ profile }) {
  const signOut = async () => {
    await supabase.auth.signOut();
    window.location.reload();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F1F7FC] px-6">
      <div className="w-full max-w-md bg-white rounded-2xl border border-stone-200 shadow-sm p-10 text-center">
        <div className="mx-auto mb-6 w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center">
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            className="text-amber-600"
          >
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </div>

        <h1 className="serif text-2xl text-stone-900 mb-2">
          Awaiting approval
        </h1>
        <p className="text-sm text-stone-600 sans mb-6">
          You're signed in as{" "}
          <span className="mono text-stone-900">{profile?.email}</span>, but
          your account hasn't been approved yet. A firm admin needs to grant
          access before you can use the workbench.
        </p>

        <p className="text-xs text-stone-500 sans mb-8">
          If you think this is a mistake, contact your firm admin and ask them
          to flip your <span className="mono">approved</span> flag in the
          Supabase user_profiles table.
        </p>

        <button
          onClick={signOut}
          className="px-4 py-2 rounded-lg border border-stone-300 bg-white hover:bg-stone-50 sans text-sm text-stone-700"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
